export const aciViewGarden = {
    iconName: 'view-garden',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    d: 'M16.418 20.274c2.027-.773 3.405-2.095 3.078-2.952-.327-.857-2.235-.925-4.262-.152-2.028.773-3.406 2.095-3.079 2.952.327.858 2.236.925 4.263.152z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M12.158 20.12c.327-.856-1.05-2.178-3.078-2.951-2.027-.774-3.936-.706-4.263.151-.327.858 1.051 2.18 3.079 2.953 2.027.773 3.935.705 4.262-.152zM12.154 14.078v6.582M12.154 11.141a1.771 1.771 0 100-3.543 1.771 1.771 0 000 3.543z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M18.65 9.37a2.362 2.362 0 00-2.417-2.362 2.362 2.362 0 10-4.079-2.362 2.362 2.362 0 10-4.086 2.362 2.362 2.362 0 100 4.724 2.362 2.362 0 104.087 2.362 2.36 2.36 0 004.02.361 2.362 2.362 0 00.058-2.723A2.361 2.361 0 0018.65 9.37z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
